/* --------------------------------------------------------------------------------------
   xwPopover.directive.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved. 
   
   Copyright protection claimed includes all forms and matters of copyrightable material 
   and information now allowed by statutory or judicial law or hereinafter granted, 
   including without limitation, material generated from the software programs which 
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

/*eslint semi: ["error", "never"]*/
 export class xwPopover {
  /*@ngInject*/
  constructor () {
    this.restrict = 'A'
    this.scope = {}
  }
  link(scope, elem, attrs) {
    const options = {
      tap: (attrs.tap == 'true'),
      targetControl: attrs.targetControl,
      arrowPosition: attrs.arrowPosition,
      height: attrs.height
    }

    setTimeout(() => elem.first().xrxpopover(options), 70)


    elem.on('$destroy', () => {
      elem.first().xrxpopover('destroy')
      elem = null
    })
  }
  static directiveFactory() {
    xwPopover.instance = new xwPopover()
    return xwPopover.instance
  }
}



// WEBPACK FOOTER //
// ./src/app/xrxWrappers/xwPopover.directive.js